// ============================================================
// src/i18n/index.js — Configuration react-i18next
// 5 langues : fr | en | es | de | tl
// ============================================================

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import de from './locales/de/translation.json';
import tl from './locales/tl/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      es: { translation: es },
      de: { translation: de },
      tl: { translation: tl },
    },
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'es', 'de', 'tl'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'js_language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;


// ============================================================
// src/components/LanguageSwitcher.jsx
// ============================================================

import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' },
  { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
  { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
  { code: 'de', label: 'DE', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'tl', label: 'TL', flag: '🇵🇭', name: 'Tagalog' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  return (
    <div style={styles.container}>
      {LANGUAGES.map(lang => (
        <button
          key={lang.code}
          onClick={() => i18n.changeLanguage(lang.code)}
          title={lang.name}
          style={{
            ...styles.btn,
            ...(i18n.language === lang.code ? styles.active : {}),
          }}
        >
          <span style={styles.flag}>{lang.flag}</span>
          <span style={styles.code}>{lang.label}</span>
        </button>
      ))}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 4,
    border: '1px solid rgba(201,168,76,0.2)',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
    color: 'var(--text-muted, #8A7E6A)',
  },
  active: {
    border: '1px solid rgba(201,168,76,0.6)',
    background: 'rgba(201,168,76,0.1)',
    color: 'var(--gold, #C9A84C)',
  },
  flag: { fontSize: 14 },
  code: { fontSize: 10, letterSpacing: 1, fontWeight: 400 },
};


// ============================================================
// USAGE dans App.js / index.js
// Ajouter en haut du fichier :
// import './i18n';
//
// USAGE dans un composant :
// import { useTranslation } from 'react-i18next';
// const { t } = useTranslation();
// <h1>{t('hero.title')}</h1>
// <button>{t('auth.login_btn')}</button>
// ============================================================
